module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_8023.a056f5d9.png";